import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MescommandesPageRoutingModule } from './mescommandes-routing.module';

import { MescommandesPage } from './mescommandes.page';
import { ExploreContainerComponentModule } from '../explore-container/explore-container.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ExploreContainerComponentModule,
    MescommandesPageRoutingModule
  ],
  declarations: [MescommandesPage]
})
export class MescommandesPageModule {}
